import React, { Component } from 'react';
import PropTypes from 'prop-types';

import isDeprecated from 'component-lib/isDeprecated';
import displayName from 'component-lib/displayName';

import './CustomCheckbox.scss';

export default class CustomCheckbox extends Component {
    static displayName = displayName('CustomCheckbox');

    static propTypes = {
        isChecked: PropTypes.bool.isRequired,
        forceHover: PropTypes.bool,
    };

    static defaultProps = {
        forceHover: false,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.isChecked !== prevState.cachedIsChecked) {
            return {
                justChanged: true,
                cachedIsChecked: nextProps.isChecked,
            };
        }

        return null;
    }

    constructor(props) {
        super(props);

        isDeprecated(CustomCheckbox, 'Forms/Checkboxes/LargeCheckbox');

        this.state = {
            isHover: false,
            justChanged: false,
        };

        this.onMouseOver = this.onMouseOver.bind(this);
        this.onMouseOut = this.onMouseOut.bind(this);
    }

    onMouseOver() {
        this.setState({ isHover: true });
    }

    onMouseOut() {
        this.setState({ isHover: false, justChanged: false });
    }

    render() {
        let className = 'custom-checkbox';
        if ((this.state.isHover || this.props.forceHover) && !this.state.justChanged) {
            className += '-hovered';
        } else if (this.props.isChecked) {
            className += '-checked';
        }

        return (
            <span
                className={className}
                data-checked={this.props.isChecked}
                onMouseOver={this.onMouseOver}
                onMouseOut={this.onMouseOut}
            />
        );
    }
}
